import UILabel from "components/ui/UILabel";
import { Theme } from "styled";
import styled, { css } from "styled-components";
import { formatCurrency } from "utils/string";

const Wrapper = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1 1 auto;
`;

const Main = styled.div<{ $inactive: boolean }>`
  position: relative;

  display: flex;
  flex-direction: column;
  gap: 4px;

  ${({ $inactive }) =>
    $inactive &&
    css`
    opacity: 0.7;
  `}
`;

const Label = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const Amount = styled(UILabel.XLarge)`
  display: flex;
  align-items: center;

  font-size: ${(props) => props.theme.fontSizes.lg}px;
  letter-spacing: ${(props) => props.theme.letterSpacings.lg}px;
  font-weight: ${(props) => props.theme.fontWeights.bold};
  line-height: 1;
`;

const getTagStyles = ({
  theme,
  $status,
}: {
  theme: Theme;
  $status: string;
}) => {
  switch ($status) {
    case "primary":
    case "active":
      return `
        background: ${theme.colors.primary};
        color: ${theme.reverseColors.primary};
      `;
    case "secondary":
      return `
        box-shadow: 0 0 0 1px ${theme.colors.primary}88 inset;
        color: ${theme.colors.text};
      `;
    case "inactive":
      return `
        background: ${theme.colors.text}22;
        color: ${theme.colors.text}99;
      `;
    default:
      return "";
  }
};

const Tag = styled.div<{ $status: string }>`
  display: flex;
  width: fit-content;
  align-items: center;
  padding: 4px 6px;
  min-height: 20px;

  border-radius: 3px;

  ${getTagStyles}
`;

interface Props {
  label: string;
  amount: number;
  status?: string;
}

const AccountBalance = ({ label, amount, status }: Props) => (
  <Wrapper>
    <Main $inactive={status === "inactive"}>
      <Label>
        <UILabel.Medium>{label}</UILabel.Medium>
      </Label>
      <Amount bold color={status === "inactive" ? "text" : "primary"}>
        {formatCurrency(amount, true)}
      </Amount>
    </Main>

    {status && (
      <Tag $status={status}>
        <UILabel.Micro wideCaps bold>
          {status}
        </UILabel.Micro>
      </Tag>
    )}
  </Wrapper>
);

export default AccountBalance;
